import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SignupBookCallView, SignupLayout } from '../components';
import { useSignupBookCallViewController } from '../controllers';

const SignupBookCallPage: React.FC = () => {
  const { embedUrl, booked, done } = useSignupBookCallViewController();

  return (
    <SignupLayout
      scrollsInside
      // A scheduler that announced the booking has raised a button on the screen itself, and a second offer of
      // the same thing is just noise.
      footerAction={booked ? undefined : (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Don&apos;t need a walkthrough? Get started right away.
          </Typography>
          <Button variant="outlined" endIcon={<ArrowForwardIcon />} onClick={done}>
            Continue to your account
          </Button>
        </Stack>
      )}
    >
      <SignupBookCallView embedUrl={embedUrl} booked={booked} onDone={done} />
    </SignupLayout>
  );
};

export default SignupBookCallPage;
